import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, HostListener, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import 'zone.js';
import { calendarDays, calendarMonths } from 'src/app/shared/constants/calendar.constant';
import { GlobalService, Guest, IEventRegisterReq, IRegisterRequest, ResponderQuestionAnswer } from 'src/app/shared/services/global.service';
import { AddToCalendarComponent } from 'src/app/components/add-to-calendar/add-to-calendar.component';
import { FINRA_DISCLOSURE_TEXT } from 'src/app/shared/constants/app.constants';
@Component({
  selector: 'app-multi-event',
  templateUrl: './multi-event.component.html',
  styleUrls: ['./multi-event.component.scss']
})
export class MultiEventComponent {

  @Input() selectedEvent: any;
  @Input() eventList: any[] = [];
  @Output() notifyMultiEvent = new EventEmitter<any>();

  eventsList: any[] = [];
  //@Input() registrationformdata:any;

  constructor(private globalService: GlobalService) {
  }

  
 ngOnChanges(changes: SimpleChanges) {
    if (changes['eventList'] || changes['selectedEvent']) {
      this.preselect();
    }
  }

  private preselect() {
    const selectedId = this.selectedEvent?.EventId != null
      ? String(this.selectedEvent.EventId)
      : null;

    this.eventsList = (this.eventList || []).map(e => ({
      ...e,
      checked: selectedId ? String(e.eventId) === selectedId : !!e.checked
    }));

    this.notifyMultiEvent.emit(this.eventsList);
  }

  ngOnInit() {
    this.preselect();
  };

 

  onEventChange(item: any, $event: any) {
    item.checked = $event.currentTarget.checked;

    this.notifyMultiEvent.emit(this.eventsList)
    //console.log(this.eventsList)
  }
}


